const mediaBaseUrl = "/backoffice/media";

type PropsType = {
    imageId: string | null;
    filename: string | null;
    alt: string;
};

function MaterialThumbnail({ imageId, filename, alt }: PropsType) {
    if (!imageId || !filename) {
        return <div className={"material-thumbnail material-thumbnail-empty"} />;
    }

    return (
        <img
            className={"material-thumbnail"}
            src={`${mediaBaseUrl}/${imageId}/${filename}`}
            alt={alt}
            loading={"lazy"}
        />
    );
}

export default MaterialThumbnail;
